import { render, staticRenderFns } from "./artificialWechatAlipay.vue?vue&type=template&id=c1783f2a&scoped=true&"
import script from "./artificialWechatAlipay.vue?vue&type=script&lang=js&"
export * from "./artificialWechatAlipay.vue?vue&type=script&lang=js&"
import style0 from "./artificialWechatAlipay.vue?vue&type=style&index=0&id=c1783f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1783f2a",
  null
  
)

export default component.exports